import React from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, Button, Divider
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PixIcon from '@mui/icons-material/Pix';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';

export default function Assinatura() {
  const handleEnviarWhatsApp = () => {
    window.open(
      `https://wa.me/5592981800808?text=Olá! Segue o comprovante do pagamento da assinatura.`,
      '_blank'
    );
  };

  const historicoPagamentos = [
    { mes: 'Abril/2025', vencimento: '30/04/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Maio/2025', vencimento: '30/05/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Junho/2025', vencimento: '30/06/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Julho/2025', vencimento: '30/07/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Agosto/2025', vencimento: '30/08/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Setembro/2025', vencimento: '30/09/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Outubro/2025', vencimento: '30/10/2025', valor: 'R$ 150,00', status: 'pago' },
    { mes: 'Novembro/2025', vencimento: '30/11/2025', valor: 'R$ 150,00', status: 'aberto' },
  ];

  const now = new Date();
  const ano = now.getFullYear();
  const validade = `30/07/${ano} a 30/08/${ano}`;

  return (
    <Box sx={{ p: 3 }}>
      {/* Cabeçalho */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={600} sx={{ color: '#202124', mb: 1 }}>
          Assinatura do Sistema
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gerencie sua assinatura e visualize o histórico de pagamentos
        </Typography>
      </Box>

      {/* Cards de Informação */}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 3, mb: 4 }}>
        {/* Card PIX */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <PixIcon sx={{ fontSize: 32, color: '#00A868', mr: 2 }} />
            <Typography variant="h6" fontWeight={600}>
              Pagamento via PIX
            </Typography>
          </Box>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Chave PIX (Celular):
          </Typography>
          <Typography variant="h5" fontWeight={700} sx={{ color: '#1976d2', mb: 2 }}>
            (92) 98180-0808
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Valor mensal: <strong>R$ 150,00</strong>
          </Typography>
          <Button
            variant="contained"
            color="success"
            startIcon={<WhatsAppIcon />}
            fullWidth
            onClick={handleEnviarWhatsApp}
            sx={{ mt: 2 }}
          >
            Enviar Comprovante
          </Button>
        </Paper>

        {/* Card Status */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Status da Assinatura
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Validade Atual:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {validade}
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Próximo Vencimento:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              30/11/2025
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Status:
            </Typography>
            <Chip
              icon={<PendingIcon />}
              label="Pagamento Pendente"
              color="warning"
              sx={{ mt: 1 }}
            />
          </Box>
        </Paper>
      </Box>

      {/* Histórico de Pagamentos */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{ p: 3, bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h6" fontWeight={600}>
            Histórico de Pagamentos
          </Typography>
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#fafafa' }}>
                <TableCell><strong>Mês</strong></TableCell>
                <TableCell><strong>Vencimento</strong></TableCell>
                <TableCell><strong>Valor</strong></TableCell>
                <TableCell align="center"><strong>Status</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historicoPagamentos.map((pagamento, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:hover': { bgcolor: '#f5f5f5' },
                    transition: 'background-color 0.2s'
                  }}
                >
                  <TableCell>{pagamento.mes}</TableCell>
                  <TableCell>{pagamento.vencimento}</TableCell>
                  <TableCell>{pagamento.valor}</TableCell>
                  <TableCell align="center">
                    {pagamento.status === 'pago' ? (
                      <Chip
                        icon={<CheckCircleIcon />}
                        label="Pago"
                        color="success"
                        size="small"
                      />
                    ) : (
                      <Chip
                        icon={<PendingIcon />}
                        label="Aberto"
                        color="warning"
                        size="small"
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
